module.exports = __webpack_public_path__ + "img/icon_oro.83ae52ce.png";